export const CONDITION_SET = 'character.CONDITION_SET';
export const CONDITION_ADD = 'character.CONDITION_ADD';
export const CONDITION_REMOVE = 'character.CONDITION_REMOVE';
export const CONDITIONS_SET = 'character.CONDITIONS_SET';
export const CONDITIONS_SET_COMMIT = 'character.CONDITIONS_SET_COMMIT';
